"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadsUpPanelForEditingVehicleRegistrationNumber = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var HeadsUpPanelForEditingVehicleRegistrationNumber = exports.HeadsUpPanelForEditingVehicleRegistrationNumber = /** @class */ (function (_super) {
    __extends(HeadsUpPanelForEditingVehicleRegistrationNumber, _super);
    function HeadsUpPanelForEditingVehicleRegistrationNumber(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSuccessfulTransactionText: true
        };
        return _this;
    }
    HeadsUpPanelForEditingVehicleRegistrationNumber.prototype.componentDidMount = function () {
        var _this = this;
        var registrationNumber = this.props.interaction.vehicles[0].registrationNumber;
        var changeOfVehicleRegistrationNumberProperty = "changeOfVehicleRegistration".concat(registrationNumber, "Count");
        this.customerPortalService.getPartyPropertyByPropertyKey(changeOfVehicleRegistrationNumberProperty).subscribe(function (property) {
            var hasChangedVrn = property != null && parseInt(property.value) > 0;
            if (hasChangedVrn) {
                var submitButton = document.getElementById("navigatorNext");
                if (submitButton) {
                    submitButton.disabled = hasChangedVrn;
                }
                _this.setState({
                    showSuccessfulTransactionText: !hasChangedVrn
                });
            }
        });
    };
    HeadsUpPanelForEditingVehicleRegistrationNumber.prototype.render = function () {
        return (React.createElement("div", { className: "section-panel" }, this.renderWording()));
    };
    HeadsUpPanelForEditingVehicleRegistrationNumber.prototype.renderWording = function () {
        var wordingElement = React.createElement(React.Fragment, null);
        if (this.state.showSuccessfulTransactionText) {
            wordingElement = React.createElement("p", { className: "text-center mx-4 mb-0 banner banner-info" },
                "Heads up - this change is only allowed ",
                React.createElement("strong", null, "once"),
                " in your subscription lifecycle. But good news,",
                ' ',
                React.createElement("strong", null, "there\u2019s no extra cost"),
                " for replacing your registration number");
        }
        else {
            wordingElement = React.createElement("p", { className: "text-center mx-4 mb-0 banner banner-info" }, "Sorry, changing registration number is not allowed because you\u2019ve already done it once in a past");
        }
        return wordingElement;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], HeadsUpPanelForEditingVehicleRegistrationNumber.prototype, "customerPortalService", void 0);
    return HeadsUpPanelForEditingVehicleRegistrationNumber;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=HeadsUpPanelForEditingVehicleRegistrationNumber.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/HeadsUpPanelForEditingVehicleRegistrationNumber.js
// module id = 3156
// module chunks = 0